import type {TFunction} from 'i18next';
import type {STATUS} from '@/domain/entities/ForestMassStatus';

export const getStatusLabel = (status: STATUS, t: TFunction): string => {
  const statusLabels: Record<STATUS, string> = {
    FOREST_MASS_CREATED: t('status.forestMassCreated'),
    CUT_FORCED: t('status.cutForced'),
    PENDING_PLOT_INVENTORIES: t('status.pendingPlotInventories'),
    PENDING_UAV_FLIGHT: t('status.pendingUavFlight'),
    PENDING_PLOT_INVENTORY_APPRAISER: t('status.pendingPlotInventoryAppraiser'),
    CUT_PENDING: t('status.cutPending'),
    WEIGHT_PENDING: t('status.weightPending'),
    CUT_WEIGHTED: t('status.cutWeighted'),
    PENDING_INVENTORY_PLOTS: t('status.pendingInventoryPlots'),
    PENDING_SLAM: t('status.pendingSlam'),
    INVENTORY_PLOTS_COMPLETED: t('status.inventoryPlotsCompleted'),
    UAV_FLIGHT_DONE: t('status.uavFlightDone'),
    METRICS_PROCESSING: t('status.metricsProcessing'),
    METRICS_SUCCESSFUL: t('status.metricsSuccessful'),
    METRICS_FAILED: t('status.metricsFailed'),
  };

  return Object.hasOwn(statusLabels, status) ? statusLabels[status] : status;
};
